<template>
  <tr
    style="cursor: pointer;"
    :class="{ 'pink lighten-5': batch.hasDuplicate, 'blue lighten-5': updated && !batch.hasDuplicate, 'green lighten-5': created && !batch.hasDuplicate, 'grey lighten-4': closed && !batch.hasDuplicate }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="toggleEditDialog"
  >
    <td @click.stop>
      <v-checkbox
        v-model="selected"
        :color="$store.state.global.pages.allocation.color"
        hide-details
      ></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, batch)) || "-" }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ !!getObjectPathRootExists(header.value, batch) ? displayDecimal(getObjectPath(header.value, batch),header.decimals) : "-" || "-" }}</span>
      <span v-if="header.type == 'text'">{{ getObjectPath(header.value, batch) || "-" }}</span>

      <span v-if="header.type == 'dayBool'">
        <v-icon v-if="getObjectPath(header.value, batch)" color="amber darken-1">wb_sunny</v-icon>
        <v-icon v-else color="blue-grey darken-3">nights_stay</v-icon>
      </span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <v-tooltip left v-for="(field, i) in operations" :key="i">
          <v-btn
            icon
            flat
            color="grey"
            slot="activator"
            :disabled="closed"
            @click="confirmUpdateBatchField(field)"
          >
            <v-icon
              color="green lighten-2"
              v-if="batch[field.field] == 'CONFIRMED' || batch[field.field] == '1'"
            >{{field.icon}}</v-icon>
            <v-icon color="orange lighten-2" v-if="batch[field.field] == 'REVIEW'">{{field.icon}}</v-icon>
            <v-icon
              color="grey"
              v-if="batch[field.field] == 'NOT SET' || batch[field.field] == '0' || batch[field.field] == null"
            >{{field.icon}}</v-icon>
          </v-btn>
          <span>
            {{`${field.label} data is ${batch[field.field]} for this batch`}}
            <br />
            {{batch[field.notesField] ? `Notes: ${batch[field.notesField]}` : ``}}
          </span>
        </v-tooltip>

        <v-btn
          icon
          flat
          :color="closed ? $store.state.global.pages.allocation.color : 'grey'"
          @click="commitDialog = !commitDialog"
        >
          <v-icon>save</v-icon>
        </v-btn>
        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile title="Edit" icon="edit" :onClick="toggleEditDialog"></basic-list-tile>
            <v-divider inset></v-divider>
            <v-list-tile
              v-for="(field, i) in operations"
              :key="i"
              @click="confirmUpdateBatchField(field)"
              ripple
            >
              <v-list-tile-action>
                <v-icon
                  v-if="batch[field.field]== 'CONFIRMED' || batch[field.field]== '1'"
                  color="green lighten-2"
                >{{field.icon}}</v-icon>
                <v-icon v-if="batch[field.field]== 'REVIEW'" color="orange lighten-2">{{field.icon}}</v-icon>
                <v-icon
                  v-if="batch[field.field]== 'NOT SET' || batch[field.field] == '0' || batch[field.field]== 'UNCONFIRMED'"
                  color="grey lighten-2"
                >{{field.icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{`Update ${field.label} Data`}}</v-list-tile-title>
            </v-list-tile>
            <v-divider inset></v-divider>
            <basic-list-tile
              title="Delete Batch"
              v-if="!closed"
              icon="delete"
              color="red lighten-3"
              :onClick="toggleDeleteDialog"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->

    <!-- Actions confirmed dialog -->
    <v-dialog
      lazy
      v-model="actionConfirmationDialog"
      max-width="700px"
      @keydown.esc="actionConfirmationDialog = false"
    >
      <single-actions
        :batch="batch"
        :fieldData="fieldData"
        :notes="currentNotes"
        :status="currentStatus"
        @close="actionConfirmationDialog = false"
        @actionComplete="actionComplete()"
      ></single-actions>
    </v-dialog>
    <!-- Batch Commit dialog -->
    <v-dialog lazy v-model="commitDialog" max-width="400px" @keydown.esc="commitDialog = false">
      <commit-batch @close="commitDialog = false" :batch="batch"></commit-batch>
    </v-dialog>
    <!-- Batch edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="900px" @keydown.esc="editDialog = false">
      <edit-batch @close="editDialog = false" :batch="batch"></edit-batch>
    </v-dialog>
    <!-- Batch Delete dialog -->
    <v-dialog lazy v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <delete-batch @close="deleteDialog = false" :batch="batch"></delete-batch>
    </v-dialog>
  </tr>
</template>

<script>
import EditBatch from './batchEdit'
import DeleteBatch from './batchDelete'
import CommitBatch from './batchCommit'
import FormatDates from '@/services/mixins/formatDates'
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'
import SingleActions from '@/modules/batchAllocations/staging/actions/singleActions.vue'

import CreatedUpdatedRows from '@/services/mixins/createdUpdatedRows'
import RowDisplayMethods from '@/services/mixins/rowDisplayMethods'
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  components: {
    EditBatch,
    DeleteBatch,
    CommitBatch,
    SingleActions,
  },
  props: {
    batch: Object,
    headers: Array,
    value: Boolean,
  },
  data() {
    return {
      prefix: 'batch',
      editDialog: false,
      commitDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      actionsMenu: false,
      currentStatus: '',
      currentNotes: '',
      fieldData: {},
      operations: [
        {
          field: 'tipConfirmed',
          label: 'Tip',
          notesField: 'tipNotes',
          icon: this.$store.state.global.pages.tip.icon,
        },
        {
          field: 'siteConfirmed',
          label: 'Site',
          notesField: 'siteNotes',
          icon: this.$store.state.global.pages.site.icon,
        },
        {
          field: 'amendmentsConfirmed',
          label: 'Amendments',
          notesField: 'amendmentsNotes',
          icon: 'post_add',
        },
      ],
    }
  },
  computed: {
    closed() {
      return this.batch.commited
    },
    selected: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', { value: val, object: this.batch })
      },
    },
  },
  methods: {
    toggleEditDialog() {
      if (this.$store.state.user.userAuthClass.allocationStagingWrite)
        this.editDialog = !this.editDialog
    },
    toggleDeleteDialog() {
      this.deleteDialog = !this.deleteDialog
    },
    confirmUpdateBatchField(payload) {
      this.fieldData = payload
      this.currentStatus = this.batch[payload.field]
      this.currentNotes = this.batch[payload.notesField]
      this.actionConfirmationDialog = true
    },
    actionComplete() {
      this.fieldData = {}
      this.actionConfirmationDialog = false
    },
  },
}
</script>